// extracted by mini-css-extract-plugin
export default {"textSpecialShieldRoot":"textSpecialShieldRoot___mLNnc","s":"s___iAxeL","m":"m___SAnpX","l":"l___iuQv3","textSpecialShieldImg":"textSpecialShieldImg___dyhsX"};